var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":require("@/assets/images/pic/loading.gif")}})]),_c('canvas-snow',{attrs:{"snowId":"snow_out"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }